var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c("b-col", [
        _c(
          "div",
          { staticClass: "club-group" },
          _vm._l(Object.keys(_vm.frequencies), function (freq) {
            return _c(
              "div",
              {
                key: freq,
                staticClass: "club-card",
                class: {
                  selected: _vm.selectedOrderFrequencyComputed === freq,
                },
                on: {
                  click: function ($event) {
                    _vm.selectedOrderFrequencyComputed = freq
                  },
                },
              },
              [
                _c("div", { staticClass: "card-inner" }, [
                  _c("div", { staticClass: "graphic" }, [
                    _c("div", {
                      staticClass: "image",
                      style: {
                        backgroundImage: `url('${_vm.frequencyImage}')`,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "club-card-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("h3", [_vm._v(_vm._s(_vm.frequency(freq)))]),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }